import {
  Chip,
  ChipColor,
  ChipProps,
} from "shared-web/components/base/informational/Chip"
export interface FilterChipProps<T extends { name: string }>
  extends Omit<ChipProps, "color" | "deletable"> {
  selectedFilters: T[]
  filterTitle: string
  includeIndex?: boolean
  maxDisplayed?: number
  color?: ChipColor
}

export function FilterChip<T extends { name: string }>(
  props: FilterChipProps<T>
) {
  const {
    selectedFilters,
    includeIndex = false,
    filterTitle,
    maxDisplayed = 3,
    color = "gray",
    ...otherProps
  } = props

  if (!selectedFilters || selectedFilters.length === 0) return

  const getChipText = () => {
    const filterTextArr = selectedFilters.map(
      (filter, index) =>
        `${includeIndex ? `${String(index + 1)}: ` : ""} ${filter.name}`
    )
    const lengthOverflow = filterTextArr.length - maxDisplayed

    let filterString = filterTextArr.join(", ")
    if (lengthOverflow > 0) {
      filterString = `${filterTextArr
        .slice(0, maxDisplayed)
        .join(", ")}, + ${lengthOverflow} ${
        lengthOverflow > 1 ? "others" : "other"
      }`
    }

    if (!filterTitle) {
      return `${filterString}`
    }

    return `${filterTitle[0].toUpperCase()}${filterTitle.slice(
      1
    )}: ${filterString}`
  }

  return <Chip color={color} text={getChipText()} deletable {...otherProps} />
}
